/** Settle superseded promises as well as cancelling their timers. */
export function createDebouncedOptionsLoader<T>(
  fetchOptions: (search: string) => Promise<T[]>,
  delay: number,
) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pending: ((options: T[]) => void) | undefined;
  const cancel = () => {
    if (timer !== undefined) clearTimeout(timer);
    timer = undefined;
    pending?.([]);
    pending = undefined;
  };
  return {
    cancel,
    load: (search: string) => {
      cancel();
      return new Promise<T[]>((resolve, reject) => {
        pending = resolve;
        timer = setTimeout(() => {
          timer = undefined;
          pending = undefined;
          fetchOptions(search).then(resolve, reject);
        }, delay);
      });
    },
  };
}
